var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as secp from "@noble/secp256k1";
import { concat } from "uint8arrays/concat";
import { randomBytes } from "../../crypto";
import { AbstractKeypair, KeypairType } from "./types";
export function secp256k1PublicKeyToCompressed(publicKey) {
    if (publicKey.length === 64) {
        publicKey = concat([[4], publicKey], 65);
    }
    const point = secp.Point.fromHex(publicKey);
    return point.toRawBytes(true);
}
export function secp256k1PublicKeyToFull(publicKey) {
    if (publicKey.length === 64) {
        publicKey = concat([[4], publicKey], 65);
    }
    const point = secp.Point.fromHex(publicKey);
    return point.toRawBytes(false);
}
export function secp256k1PublicKeyToRaw(publicKey) {
    const point = secp.Point.fromHex(publicKey);
    return point.toRawBytes(false).slice(1);
}
export const Secp256k1Keypair = class Secp256k1Keypair extends AbstractKeypair {
    constructor(privateKey, publicKey) {
        let pub = publicKey;
        if (pub) {
            pub = secp256k1PublicKeyToCompressed(pub);
        }
        super(privateKey, pub);
        this.type = KeypairType.secp256k1;
    }
    static generate() {
        return __awaiter(this, void 0, void 0, function* () {
            const privateKey = randomBytes(32);
            const publicKey = secp.getPublicKey(privateKey);
            return new Secp256k1Keypair(privateKey, publicKey);
        });
    }
    privateKeyVerify(key = this._privateKey) {
        if (key) {
            return secp.utils.isValidPrivateKey(key);
        }
        return true;
    }
    publicKeyVerify(key = this._publicKey) {
        if (key) {
            try {
                secp.Point.fromHex(key);
                return true;
            }
            catch (_a) {
                return false;
            }
        }
        return true;
    }
    sign(msg) {
        return __awaiter(this, void 0, void 0, function* () {
            const [signature, recid] = yield secp.sign(msg, this.privateKey, {
                recovered: true,
                der: false,
            });
            return concat([signature, [recid]], signature.length + 1);
        });
    }
    verify(msg, sig) {
        try {
            const _sig = secp.Signature.fromCompact(sig.slice(0, 64));
            return secp.verify(_sig, msg, this.publicKey);
        }
        catch (_a) {
            return false;
        }
    }
};
//# sourceMappingURL=secp256k1.js.map